import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const SCROLL_EXCLUSIONS = ['/logics', '/questions'];

const isExcluded = (prevPath: string, nextPath: string) =>
  SCROLL_EXCLUSIONS.some((segment) => prevPath.includes(segment) && nextPath.includes(segment));

/**
 * Scroll to top of page when path changes.
 *
 * A child view can override this behavior locally by rendering `ScrollToBottom`,
 * which performs its own `scrollTo` in a later effect (post-order) so its scroll
 * position wins.
 *
 * @see https://stackoverflow.com/questions/36904185/react-router-scroll-to-top-on-every-transition
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (!isExcluded(prevPathname.current, pathname)) {
      window.scrollTo(0, 0);
    }
    prevPathname.current = pathname;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
